<template>
  <div style="height: 100%">
    <div class="newInvitation" v-if="showSelect">
      <div v-if="sourceIsH5" class="navBar-wrap">
        <NavBar :narBarTitle="title" />
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <!-- <div v-if="sourceIsH5" style="height: 45px" /> -->
        <div class="content">
          <div class="headerBar hidden">
            <div class="customerButton" @click="toSendInvitation">
              <div class="customerName">
                {{ $t('发送邀约链接给访客自己填') }}
              </div>
            </div>
            <div class="historyButton" @click="toVisitors">
              <img src="@/assets/images/history.png" alt="" class="tabImg" />
              <div class="historyName">{{ $t('邀约历史') }}</div>
            </div>
          </div>
          <van-form>
            <van-field
              v-model="intervieweeName"
              :label="$t('被访人：')"
              class="space hidden"
              :placeholder="$t('请输入')"
              readonly
              @click="getSearchList"
            />
            <div class="purposeBox hidden">
              <div class="purpose-title">
                <van-field
                  :label="$t('来访目的：')"
                  class="spaceBlock"
                  :style="{ height: '100%' }"
                />
              </div>
              <van-radio-group
                v-model="radio"
                direction="horizontal"
                class="purpose-radio"
                checked-color="#009BFF"
              >
                <van-radio
                  v-for="item in purposeList"
                  :name="item.value"
                  :key="item.id"
                  >{{ item.value }}</van-radio
                >
              </van-radio-group>
            </div>
            <van-field
              :label="$t('上传免冠照')"
              class="space photo hidden"
              input-align="right"
            >
              <template #input>
                <div class="cropper">
                  <img :src="photo" class="img" />
                  <!-- option是配置，格式是对象，getbase64Data是组件的一个方法获取裁剪完的头像 2.14新增一个获取getblobData的方法 -->
                  <h5-cropper
                    :option="option"
                    @getFile="getFile"
                    @getbase64Data="getbase64Data"
                  ></h5-cropper>
                </div>
              </template>
            </van-field>
            <van-field
              v-model="visitorName"
              :label="$t('预约人：')"
              class="space spaceMargin"
              :placeholder="$t('请输入预约人')"
              maxlength="15"
              :rules="[{ required: true }]"
            />
            <van-field
              v-model="visitorMobile"
              :label="$t('手机号：')"
              class="space spaceMargin"
              :placeholder="$t('请输入手机号')"
              clearable
              :rules="[{ required: true, validator: mobileTest }]"
            />
            <van-field
              v-model="date"
              :label="$t('日期：')"
              class="space"
              :placeholder="$t('请选择访问日期')"
              @click="dateChange"
              readonly
            />
            <van-field
              :label="$t('时间：')"
              class="space"
              :placeholder="$t('请输入')"
              readonly
            >
              <template #input>
                <div @click="showTime = true">{{ visitStartTime }}</div>
                <div class="timeInterval">{{ $t('至') }}</div>
                <div @click="showEndTime = true">{{ visitEndTime }}</div>
              </template>
            </van-field>
            <!-- <div class="time-notice">
              <img src="@/assets/images/notice.png" alt="" />
              <span>注：访客需在此时间段内签到，过期则失效</span>
            </div> -->
            <van-field
              :label="$t('到访地址：')"
              class="space spaceMargin hidden"
              readonly
            >
              <template #input>
                <div
                  v-if="addressList.length == 0"
                  :style="{ color: '#c8c9cc' }"
                >
                  {{ $t('暂无地址') }}
                </div>
                <div v-else @click="showAddress = true" class="address">
                  <span>{{ currentAddress }}</span>
                  <img
                    src="@/assets/images/more.png"
                    alt=""
                    class="icon-more"
                  />
                </div>
              </template>
            </van-field>
            <van-field
              v-model="visitorCompany"
              :label="$t('访客公司：')"
              class="space hidden"
              :placeholder="$t('请输入')"
              maxlength="30"
            />
            <van-field
              v-model="visitorNumber"
              :label="$t('人数：')"
              class="space hidden"
            >
              <template #input>
                <van-stepper v-model="visitorNumber" />
              </template>
            </van-field>
            <van-field
              :label="$t('签到方式：')"
              class="space hidden"
              :placeholder="$t('请选择机器人接待点')"
              readonly
              :value="signInType"
              v-if="signInTypeList.length > 0"
              @click="showSignIn = true"
            />
            <van-field
              :label="$t('目的地选择：')"
              class="space"
              readonly
              :value="robotPT"
              v-if="showRobot"
              @click="showPT = true"
            />
            <van-field
              :label="$t('讲解路线选择：')"
              class="space"
              readonly
              :value="robotGuide"
              v-if="showGuide"
              @click="showGuidePopup = true"
            />
            <van-field
              name="switch"
              class="space switchBlock hidden"
              :label="$t('预约同时段会议室')"
              label-width="150px"
              input-align="right"
            >
              <template #input>
                <van-switch
                  :value="IsSubscribe"
                  @input="SubscribeChange"
                  size="22"
                />
              </template>
            </van-field>
            <van-field
              v-show="IsSubscribe"
              readonly
              clickable
              class="space"
              name="picker"
              :value="Conference"
              :label="$t('机器人：')"
              :placeholder="$t('点击会议室')"
            >
              <template #input>
                <div
                  v-if="ConferenceColumns.length == 0"
                  :style="{ color: '#c8c9cc' }"
                >
                  {{ $t('暂无会议室') }}
                </div>
                <div v-else @click="showHyvisible = true" class="address">
                  <span>{{ Conference }}</span>
                  <img
                    src="@/assets/images/more.png"
                    alt=""
                    class="icon-more"
                  />
                </div>
              </template>
            </van-field>
            <van-popup v-model="showConference" position="bottom">
              <van-picker
                show-toolbar
                value-key="text"
                :columns="ConferenceColumns"
                @confirm="ConferenceConfirm"
                @cancel="showConference = false"
              />
            </van-popup>
            <!-- todo isOk -->
            <van-field
              name="switch"
              class="space"
              :label="$t('时间段：')"
              v-show="IsSubscribe"
            >
              <template #input>
                <div>{{ setTime(visitStartTime, 10) }}</div>
                <div class="timeInterval">——</div>
                <div>{{ setTime(visitEndTime, 2) }}</div>

                <span v-if="!statusLoading && visitorDate"
                  >({{ IsSubscribeTitle }})</span
                >
              </template>
            </van-field>
          </van-form>
          <div class="agreeBox">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              class="agree-btn"
              @click="onConfirm"
              :loading="isLoading"
            >
              {{ buttonText }}
            </van-button>
          </div>
        </div>
      </van-pull-refresh>

      <van-calendar
        v-model="showDate"
        @confirm="choseDate"
        :title="$t('日期筛选')"
        color="#009BFF"
        :formatter="formatter"
      />
      <van-popup
        v-model="showTime"
        position="bottom"
        closeable
        safe-area-inset-bottom
      >
        <van-datetime-picker
          v-model="tmpTime"
          type="time"
          :title="$t('选择时间')"
          :min-hour="0"
          :max-hour="23"
          :show-toolbar="false"
          :filter="filter"
        />
        <div class="timeBox">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            class="time-btn"
            @click="choseTime"
            >{{ $t('确认') }}</van-button
          >
        </div>
      </van-popup>
      <van-popup
        v-model="showEndTime"
        position="bottom"
        closeable
        safe-area-inset-bottom
      >
        <van-datetime-picker
          v-model="tmpEndTime"
          type="time"
          :title="$t('选择时间')"
          :min-hour="0"
          :max-hour="23"
          :show-toolbar="false"
          :filter="filter"
        />
        <div class="timeBox">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            class="time-btn"
            @click="choseEndTime"
            >{{ $t('确认') }}</van-button
          >
        </div>
      </van-popup>
    </div>
    <div v-else class="interviewee">
      <div class="navBar-wrap">
        <div class="select-navBar">
          <div class="arrow" @click="goBackIndex">
            <van-icon name="arrow-left" />
          </div>
          <p class="title">{{ $t('选择被访人') }}</p>
        </div>
        <van-field
          v-model="searchMsg"
          :placeholder="$t('请输入搜索关键字')"
          class="search"
          @input="selectInterviewee"
        >
          <template #right-icon>
            <img src="@/assets/images/search.png" alt="" />
          </template>
        </van-field>
      </div>
      <div class="interviewee-content">
        <ul class="searchList" v-show="searchList">
          <li
            v-for="(value, idx) in searchList"
            :key="value.id"
            @click="addInterviewee(idx)"
          >
            {{ value.name }}
            <span v-show="value.departmentName"
              >({{ value.departmentName }})</span
            >
          </li>
        </ul>
      </div>
    </div>
    <van-popup v-model="showPT" position="bottom" safe-area-inset-bottom>
      <div>
        <van-radio-group v-model="result" class="timeList">
          <div>
            <van-radio
              :name="item.name"
              class="timeListCard"
              icon-size="21px"
              v-for="(item, idx) in PTList"
              :key="idx + 2500"
              @click="selectPT(item.name)"
            >
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.name }}
              </div>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
      <!-- <div class="bookBox">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="book-btn"
          @click="confirmRobot"
        >
          立即预订
        </van-button>
      </div> -->
    </van-popup>
    <van-popup v-model="showSignIn" position="bottom" safe-area-inset-bottom>
      <div>
        <van-radio-group v-model="signInResult" class="timeList">
          <div>
            <van-radio
              :name="item.name"
              class="timeListCard"
              icon-size="21px"
              v-for="(item, idx) in signInTypeList"
              :key="idx + 2500"
              @click="selectSignIn(item)"
            >
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.name }}
              </div>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
    </van-popup>
    <van-popup
      v-model="showGuidePopup"
      position="bottom"
      safe-area-inset-bottom
    >
      <div>
        <van-radio-group v-model="guideResult" class="timeList">
          <div>
            <van-radio
              :name="item.name"
              class="timeListCard"
              icon-size="21px"
              v-for="(item, idx) in guideList"
              :key="idx + 2500"
              @click="selectGuide(item.name)"
            >
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.name }}
              </div>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
      <!-- <div class="bookBox">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="book-btn"
          @click="confirmRobotGuide"
        >
          立即预订
        </van-button>
      </div> -->
    </van-popup>
    <!-- 到访地址 -->
    <van-popup v-model="showAddress" position="bottom" safe-area-inset-bottom>
      <div>
        <van-radio-group v-model="adderssResult" class="timeList">
          <div>
            <van-radio
              :name="item.id"
              class="timeListCard"
              icon-size="21px"
              v-for="(item, idx) in addressList"
              :key="item.id"
              @click="selectAddress(item)"
            >
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.address }}
              </div>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
    </van-popup>
    <!-- 会议室 -->
    <van-popup v-model="showHyvisible" position="bottom" safe-area-inset-bottom>
      <div>
        <van-radio-group v-model="ConferenceId" class="timeList">
          <div>
            <van-radio
              :name="item.id"
              class="timeListCard"
              icon-size="21px"
              v-for="(item, idx) in ConferenceColumns"
              :key="item.id"
              @click="setHyValue(item)"
            >
              <div class="timeListRange" :ref="'range' + idx">
                {{ item.name }}
              </div>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
    </van-popup>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import H5Cropper from 'vue-cropper-h5'
import { isMobileType } from '@/utils/isMobileType.js'
// import { rsaOther } from '@/utils/utils'
import JSEncrypt from 'jsencrypt'
import { I18nTemplateForSubmit } from '@/utils/i18n'

Vue.use(H5Cropper)
import {
  PublicvisitorSave,
  getDictionary,
  getUserList,
  getVisitaddress,
  visitorUpdate,
  getConfig,
  publicAppointmentList,
  getMeetingRoomByPublic,
  publicbookAppointment,
  getCompanyInfo,
  LanguagesRESTful
} from '@/services/api'
import NavBar from '@/components/navBar'
import Vue from 'vue'
import { ref } from 'vue'
import {
  Field,
  Button,
  Form,
  RadioGroup,
  Radio,
  DatetimePicker,
  Popup,
  Calendar,
  Toast,
  Icon,
  PullRefresh,
  Stepper,
  Switch,
  Picker,
} from 'vant'
import moment from 'moment'

Vue.use(Icon)
Vue.use(Field)
Vue.use(Button)
Vue.use(Form)
Vue.use(Radio)
Vue.use(Toast)
Vue.use(RadioGroup)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Calendar)
Vue.use(PullRefresh)
Vue.use(Stepper)
Vue.use(Switch)
Vue.use(Picker)

/* i18n-ignore */
const defaultLang = {
  'zh-CN': '简体中文',
  'en-US': 'English',
}

export default {
  name: 'PubilcnewInvitation',
  created() {
    if (this.signInTypeList.length > 0) {
      this.signInType = this.signInTypeList[o].value
    }
  },
  components: {
    NavBar,
  },
  data() {
    return {
      showHyvisible: false,
      Conference: '',
      showConference: false,
      IsSubscribe: true,
      user: {},
      ConferenceColumns: ['123'],
      interviewee: {},
      date: '',
      radio: '',
      visitorName: '',
      visitorMobile: '',
      purposeList: [],
      visitorDate: '',
      userList: [],
      // visitTime: '',
      visitStartTime: '12:11',
      visitEndTime: '13:12',
      visitorCompany: '',
      visitorNumber: 1,
      showTime: false,
      showEndTime: false,
      showDate: false,
      showSelect: true,
      tmpTime: '',
      tmpEndTime: '',
      searchList: [],
      searchMsg: '',
      photo: null,
      visitorPhoto: '',
      option: {
        fixedNumber: [9, 16],
        confirmButtonBackgroundColor: '#009BFF',
        cancelButtonText:this.$t('取消'),
        confirmButtonText:this.$t('确认'),
      },
      isLoading: false,
      showRobot: false,
      showPT: false,
      result: '',
      PTList: [],
      ifSending: false,
      robotPT: null,
      tmpRobotPT: null,
      sourceIsH5: true,
      isConfirm: false,
      signInList: [],
      signInType: this.$t('签到后不呼叫接待人'),
      showSignIn: false,
      signInTypeList: [],
      signInResult: '',
      robotGuide: '',
      showGuide: false,
      showGuidePopup: false,
      guideList: [],
      guideResult: '',
      tmpRobotGuide: null,
      currentAddress: null,
      addressList: [],
      showAddress: false,
      adderssResult: null,
      ifUpdate: false,
      buttonText: '',
      intervieweeName: '',
      status: null,
      invitationCode: null,
      title: '',
      IsSubscribeTitle: null,
      ConferenceId: '',
      timeUnit: 30,
      appointmentInterval: null,
      scheduledEndTime: null,
      scheduledMaxTime: 60,
      statusLoading: false, // 是否可预约loading
      formattedEndTime: '',
      relexConfig: {},
      meetingRoom: {},
      companyConfig: {},
      publicKey: '',
      visitDuration: '',
      timestamp: '',
      workspaceId: '',
      allLang: defaultLang
    }
  },
  methods: {
    filter(type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 30 === 0)
      }
      return options
    },
    async rsaOther(msg) {
      const encryptor = new JSEncrypt()
      encryptor.setPublicKey(this.companyConfig.publicKey) //设置公钥
      return encryptor.encrypt(msg)
    },
    async getValue() {
      const urlParams = new URLSearchParams(window.location.search)
      const companyCode = urlParams.get('companyCode')
      const configCode = urlParams.get('configCode')
      this.workspaceId = urlParams.get('workspaceId')
      this.relexConfig = await getConfig({ companyCode, configCode })
      this.getPurposeList('VISITOR_PURPOSE')
      this.companyConfig = await getCompanyInfo(this.relexConfig.companyCode)
      ;(this.timestamp = Math.floor(Date.now() / 1000)),
        (this.publicKey = await this.rsaOther(
          this.relexConfig.companyCode +
            '&' +
            this.relexConfig.companyId +
            'RSA' +
            this.timestamp
        ))

      this.getMeetingRoom()
    },

    setHyValue(e) {
      this.Conference = e.text
      this.ConferenceId = e.id
      this.getdateOverlap() //选择会议室后，也许校验是否有预约
      this.showHyvisible = !!0
    },
    dateChange() {
      this.showDate = true
    },
    async setBookAppointment(
      robotLocation,
      robotWorkspaceName,
      registerMode,
      robotGuide
    ) {
      // let startTime =
      //   new Date().getFullYear() +
      //   '-' +
      //   this.date +
      //   ' ' +
      //   this.setTime(this.visitStartTime, 1) +
      //   ':00'
      // let endTime =
      //   new Date().getFullYear() +
      //   '-' +
      //   this.date +
      //   ' ' +
      //   this.setTime(this.visitEndTime, 1) +
      //   ':00'

      const startTimes = this.setTime(this.visitStartTime, 10)
      const endTimes = this.setTime(this.visitEndTime, 2)
      const newStartTime =
        new Date().getFullYear() +
        '-' +
        this.date +
        ' ' +
        startTimes +
        ':' +
        '00'
      const newEndTime =
        new Date().getFullYear() + '-' + this.date + ' ' + endTimes + ':' + '00'
      const cha = moment(newEndTime).diff(moment(newStartTime), 'minutes')
      ;(this.timestamp = Math.floor(Date.now() / 1000)),
        (this.publicKey = await this.rsaOther(
          this.relexConfig.companyCode +
            '&' +
            this.relexConfig.companyId +
            'RSA' +
            this.timestamp
        ))
      let data = {
        address: this.relexConfig.address,
        developerId: this.relexConfig.companyId * 1,
        appointmentStaff: this.relexConfig.staffId, //预约人
        meetingPeopleId: this.meetingRoom.staffId,
        companyId: this.relexConfig.companyId,
        // replaceAppointmentStaff: 0, //被预约人
        meetingRoomId: this.ConferenceId,
        multiMeetingRoomIds: [this.ConferenceId],
        // appointmentPeriod: cha,
        appointmentTopic: this.$t('访客接待'),
        // visitPurpose: this.radio,
        appointmentStartTime: newStartTime,
        appointmentEndTime: newEndTime,
        // peopleId: this.interviewee.id,
        // relationMeetingId: 0,
        repeatType: 'single',
        otherPeopleRecord: JSON.stringify([
          {
            name: this.visitorName,
            mobile: this.visitorMobile,
            email: '',
            type: 'visitor',
          },
        ]),
        robotLocation: robotLocation || '',
        robotWorkspaceName: robotWorkspaceName || '',
        source: 'H5',
        registerMode: registerMode ?? '',
        robotGuide: robotGuide || '',
        remindTime: this.timeUnit,
        // visitId: null,
        rsaParam: this.publicKey,
      }

      // todo
      try {
        await publicbookAppointment(data)
      } catch (error) {
        this.IsSubscribeTitle = this.$t('不可预约')
      }
    },
    async getdateOverlap() {
      let startTime =
        new Date().getFullYear() +
        '-' +
        this.date +
        ' ' +
        this.visitStartTime +
        ':00'
      let endTime =
        new Date().getFullYear() +
        '-' +
        this.date +
        ' ' +
        this.visitEndTime +
        ':00'
      ;(this.timestamp = Math.floor(Date.now() / 1000)),
        (this.publicKey = await this.rsaOther(
          this.relexConfig.companyCode +
            '&' +
            this.relexConfig.companyId +
            'RSA' +
            this.timestamp
        ))
      try {
        const res = await publicAppointmentList({
          companyId: this.relexConfig.companyId,
          meetingRoomId: this.ConferenceId,
          date: new Date().getFullYear() + '-' + this.date,
          rsaParam: this.publicKey,
        })

        this.IsSubscribeTitle = this.$t('可预约')

        if (res.length) {
          let status = false
          res.forEach((item) => {
            if (item.actualEndTime) {
              const actualEnd = new Date(item.actualEndTime)
              const minutes = actualEnd.getMinutes()
              let roundedMinutes
              if (minutes < 15) {
                roundedMinutes = 15
              } else if (minutes < 30) {
                roundedMinutes = 30
              } else if (minutes < 45) {
                roundedMinutes = 45
              } else {
                roundedMinutes = 0
                actualEnd.setHours(actualEnd.getHours() + 1)
              }
              actualEnd.setMinutes(roundedMinutes)
              this.formattedEndTime = `${actualEnd.getFullYear()}-${(
                actualEnd.getMonth() + 1
              )
                .toString()
                .padStart(2, '0')}-${actualEnd
                .getDate()
                .toString()
                .padStart(2, '0')} ${actualEnd
                .getHours()
                .toString()
                .padStart(2, '0')}:${actualEnd
                .getMinutes()
                .toString()
                .padStart(2, '0')}:00`
              if (
                dayjs(this.formattedEndTime).format('YYYY-MM-DD HH:mm:ss') >
                  dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') &&
                dayjs(item.appointmentStartTime).format('YYYY-MM-DD HH:mm:ss') <
                  dayjs(endTime).format('YYYY-MM-DD HH:mm:ss')
              ) {
                status = true
              }
              if (
                dayjs(this.formattedEndTime).format('YYYY-MM-DD HH:mm:ss') ==
                  dayjs(endTime).format('YYYY-MM-DD HH:mm:ss') &&
                dayjs(item.appointmentStartTime).format(
                  'YYYY-MM-DD HH:mm:ss'
                ) == dayjs(startTime).format('YYYY-MM-DD HH:mm:ss')
              ) {
                status = true
              }
            } else {
              if (
                dayjs(item.appointmentEndTime).format('YYYY-MM-DD HH:mm:ss') >
                  dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') &&
                dayjs(item.appointmentStartTime).format('YYYY-MM-DD HH:mm:ss') <
                  dayjs(endTime).format('YYYY-MM-DD HH:mm:ss')
              ) {
                status = true
              }
              if (
                dayjs(item.appointmentEndTime).format('YYYY-MM-DD HH:mm:ss') ==
                  dayjs(endTime).format('YYYY-MM-DD HH:mm:ss') &&
                dayjs(item.appointmentStartTime).format(
                  'YYYY-MM-DD HH:mm:ss'
                ) == dayjs(startTime).format('YYYY-MM-DD HH:mm:ss')
              ) {
                status = true
              }
            }
          })

          if (status == true) {
            this.IsSubscribeTitle = this.$t('不可预约')
          } else {
            this.IsSubscribeTitle = this.$t('可预约')
          }
        } else {
          this.IsSubscribeTitle = this.$t('可预约')
        }
        this.statusLoading = false
      } catch (error) {
        if (error) {
          this.IsSubscribeTitle = this.$t('不可预约')
        }
      }

      let isOk = true
      // if (this.IsSubscribe) {
      //   const limitStart = moment(this.appointmentInterval, 'HH:mm')
      //   const limitEnd = moment(this.scheduledEndTime, 'HH:mm')
      //   const resultStart = this.setTime(this.visitStartTime, 10)
      //   const resultEnd = this.setTime(this.visitEndTime, 2)
      //   const dateEnd = moment(resultEnd, 'HH:mm')
      //   const dateStart = moment(resultStart, 'HH:mm')
      //   if (limitEnd < dateEnd) {
      //     Toast.fail(`预约时间最晚为 ${this.scheduledEndTime} ,您已超出,请重新选择`)
      //     isOk = false
      //     return
      //   }
      //   if (limitStart > dateStart) {
      //     Toast.fail(`预约时间最早为 ${this.appointmentInterval} ,您已提前,请重新选择`)
      //     isOk = false
      //     return
      //   }
      //   if (this.scheduledMaxTime != 24) {
      //     const limitCha = this.scheduledMaxTime * 60
      //     // console.log('限制差距Cha', limitCha)
      //     const startTimes = this.setTime(this.visitStartTime, 10)
      //     const endTimes = this.setTime(this.visitEndTime, 2)
      //     const newStartTime =
      //       new Date().getFullYear() + '-' + this.date + ' ' + startTimes + ':' + '00'
      //     const newEndTime =
      //       new Date().getFullYear() + '-' + this.date + ' ' + endTimes + ':' + '00'
      //     const cha = moment(newEndTime).diff(moment(newStartTime), 'minutes')
      //     // console.log('实际差距=多少分钟', cha)
      //     if (cha > limitCha) {
      //       Toast.fail(`会议支持最长预约时间 ${this.scheduledMaxTime}小时 `)
      //       isOk = false
      //       return
      //     }
      //   }
      // }
      if (isOk == false) {
        return
      }
    },

    async getMeetingRoom() {
      ;(this.timestamp = Math.floor(Date.now() / 1000)),
        (this.publicKey = await this.rsaOther(
          this.relexConfig.companyCode +
            '&' +
            this.relexConfig.companyId +
            'RSA' +
            this.timestamp
        ))
      try {
        this.meetingRoom = await getMeetingRoomByPublic({
          developerId: this.relexConfig.companyId,
          workspaceId: this.workspaceId || '',
          rsaParam: this.publicKey,
          configCode: this.relexConfig.configCode,
        })
      } catch (error) {}

      this.ConferenceColumns = this.meetingRoom
        .filter((room) => room.state !== 'nouse')
        .map((p) => ({
          text: p.name,
          ...p,
        }))

      this.Conference = this.ConferenceColumns[0].text
      this.ConferenceId = this.ConferenceColumns[0].id // 点击预约同时段 默认第一个
      // const item = this.ConferenceColumns.find(item => {

      //   return this.tmpRobotPT.includes(item.name)
      // })
      // if (!!item) {
      //   this.setHyValue(item)
      // }
      // this.getdateOverlap()
    },

    SubscribeChange(e) {
      // if (!this.date && !this.IsSubscribe) {
      //   Toast.fail('请选择到访日期')
      //   return
      // }
      // this.getMeetingRoom()
      // console.log('e', e)
      // this.IsSubscribe = !this.IsSubscribe
      // if (e == true) {
      //   this.statusLoading = true
      //   this.getMeetingRoom()
      //   // getMeetingRoomConfig({ developerId: this.user.companyId }).then(res => {
      //   //   this.timeUnit = res.timeUnit
      //   //   this.appointmentInterval = res.scheduledStartTime
      //   //   this.scheduledEndTime = res.scheduledEndTime
      //   //   this.scheduledMaxTime = res.scheduledMaxTime
      //   // })
      //   this.getdateOverlap()
      // } else {
      //   this.ConferenceId = ''
      // }
    },
    setTime(time, type) {
      const timeUnit = this.timeUnit
      var data
      let dataTime = new Date().getFullYear() + '-' + this.date + ' ' + time
      if (type == 1) {
        data = dayjs(dataTime).subtract(5, 'minute').format('HH:mm')
      } else if (type == 10) {
        dataTime = dayjs(dataTime).format('YYYY-MM-DD HH:mm')
        let arr = dataTime.split(' ')[1].split(':'),
          fen = parseInt(arr[arr.length - 1]),
          hour = parseInt(arr[arr.length - 2])
        let s = Math.floor(fen / timeUnit) * timeUnit
        dataTime = dataTime.split(' ')[0] + ` ${hour}:${s}`
        data = dayjs(dataTime).format('HH:mm')
        return data
      } else {
        dataTime = dayjs(dataTime).format('YYYY-MM-DD HH:mm')
        let arr = dataTime.split(' ')[1].split(':'),
          fen = parseInt(arr[arr.length - 1]),
          hour = parseInt(arr[arr.length - 2])

        if (fen > 45) {
          hour += 1
          fen = 0
          dataTime = dataTime.split(' ')[0] + ` ${hour}:${fen}`
          data = dayjs(dataTime).format('HH:mm')
        } else {
          fen = Math.ceil(fen / timeUnit) * timeUnit
          if (fen > 45) {
            hour += 1
            fen = 0
          }
          dataTime = dataTime.split(' ')[0] + ` ${hour}:${fen}`
          data = dayjs(dataTime).format('HH:mm')
        }
      }
      return data
    },
    ConferenceConfirm(e) {
      this.showConference = false
      this.Conference = e.text
      this.ConferenceId = e.id
      this.getdateOverlap() //选择会议室后，也许校验是否有预约
    },
    toVisitors() {
      this.$store.state.visitorState = 'pre'
      this.$router.push('/visitors')
    },
    toSendInvitation() {
      if (isMobileType.iOS()) {
        window.location.href = `${window.location.origin}/newwork-h5/SendInvitation`
      } else {
        this.$router.push('/SendInvitation')
      }
    },
    mobileTest() {
      return /^1[3-9]\d{9}$/.test(this.visitorMobile)
    },
    addNum() {
      this.visitorNumber = this.visitorNumber * 1 + 1
    },
    reduceNum() {
      if (this.visitorNumber <= 1) return
      this.visitorNumber = this.visitorNumber - 1
    },
    async getPurposeList(str) {
      // const res = await getDictionary(str)
      const res = [
        {
            "id": 31,
            "value": this.$t('拜访'),
            "itemKey": "VISITOR_PURPOSE"
        },
        {
            "id": 32,
            "value": this.$t('面试'),
            "itemKey": "VISITOR_PURPOSE"
        },
        {
            "id": 33,
            "value": this.$t('商务合作'),
            "itemKey": "VISITOR_PURPOSE"
        },
        {
            "id": 34,
            "value": this.$t('考察'),
            "itemKey": "VISITOR_PURPOSE"
        },
        {
            "id": 35,
            "value": this.$t('其他'),
            "itemKey": "VISITOR_PURPOSE"
        }
      ]
      this.purposeList = res
      // if (this.$route.query.visitorId) {
      //   this.title = '编辑'
      //   this.getInfo(this.$route.query.visitorId)
      // } else {
      this.radio = res[4].value
      let hour = dayjs(new Date()).format('HH') * 1 + 1
      if (hour <= 9) {
        hour = '0' + hour
      }
      hour == 24 && (hour = '00')
      this.visitStartTime = hour + ':00'
      this.visitEndTime = hour * 1 + 1 + ':00'
      this.tmpTime = this.visitStartTime
      this.tmpEndTime = this.visitEndTime
      this.intervieweeName = ''
      this.buttonText = this.$t('确定')
      this.title = this.$t('访客信息登记')
      // }
    },
    choseTime() {
      this.visitStartTime = this.tmpTime
      this.showTime = false
      this.getdateOverlap()
    },
    choseEndTime() {
      this.visitEndTime = this.tmpEndTime
      this.showEndTime = false
      let visitTime =
        dayjs(this.visitorDate).format('YYYY-MM-DD') + ' ' + this.visitStartTime
      let visitEndTime =
        dayjs(this.visitorDate).format('YYYY-MM-DD') + ' ' + this.visitEndTime
      this.visitDuration = dayjs(visitEndTime).diff(dayjs(visitTime), 'minutes')
      if (this.visitDuration > 60) {
        Toast.fail(this.$t('预约时间不得超过1小时'))
      }

      this.getdateOverlap()
    },
    choseDate(date) {
      this.date = dayjs(date).format('MM-DD')
      this.visitorDate = date
      this.showDate = false
      this.getdateOverlap()
    },
    formatter(day) {
      if (
        dayjs(day.date).format('YYYY-MM-DD') ==
        dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        day.className = 'date-border'
      }
      return day
    },
    selectInterviewee(v) {
      this.searchList = ['']
      // let arr = this.userList.filter(item => {
      //   if (!item.name) return
      //   return item.name.includes(v)
      // })
      // this.searchList = arr
    },
    addInterviewee(idx) {
      this.interviewee = this.searchList[idx]
      this.intervieweeName = this.searchList[idx].name
      this.searchMsg = ''
      this.searchList = []
      this.showSelect = true
    },
    async getSearchList() {
      this.showSelect = false
      try {
        const res = await getUserList({ companyId: this.relexConfig.companyId })
        let arr = [...res]
        let Arr = arr.filter((item) => {
          if (!item.name) return
          return item.name
        })
        this.searchList = Arr
      } catch (error) {
        console.log('getSearchList--', error)
      }
    },
    // async getUsers(companyId) {
    // console.log('getUsers--', companyId)

    //   try {
    //     const res = await getUserList({ companyId })
    //     let arr = [...res]
    //     this.userList = arr
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    goBackIndex() {
      this.searchMsg = ''
      this.searchList = []
      this.showSelect = true
    },
    async onConfirm() {
      if (this.IsSubscribeTitle == this.$t('不可预约')) {
        Toast.fail(this.$t('当前时间段不可预约'))
        return
      }
      // if (!this.intervieweeName) {
      //   Toast.fail('请输入被访人')
      //   return
      // }
      // if (!this.radio) {
      //   Toast.fail('请选择来访目的')
      //   return
      // }
      if (!this.visitorName) {
        Toast.fail(this.$t('请输入预约人姓名'))
        return
      }
      if (!this.visitorMobile || this.mobileTest() == false) {
        Toast.fail(this.$t('请输入正确的预约人手机号'))
        return
      }
      if (!this.date) {
        Toast.fail(this.$t('请选择日期'))
        return
      }
      // if (this.ifSending) {
      //   Toast.fail('人脸识别照片上传中,请稍等')
      //   return
      // }
      let visitTime =
        dayjs(this.visitorDate).format('YYYY-MM-DD') + ' ' + this.visitStartTime
      // if (dayjs(visitTime).valueOf() < dayjs().valueOf() && !this.$route.query.visitorId) {
      //   Toast.fail('到访时间/日期无效')
      //   return
      // }
      let visitEndTime =
        dayjs(this.visitorDate).format('YYYY-MM-DD') + '' + this.visitEndTime
      if (dayjs(visitTime).valueOf() >= dayjs(visitEndTime).valueOf()) {
        Toast.fail(this.$t('结束时间需大于起始时间'))
        return
      }
      this.visitDuration = dayjs(visitEndTime).diff(dayjs(visitTime), 'minutes')
      if (this.visitDuration < 30 || this.visitDuration > 60) {
        Toast.fail(this.$t('预约时间不得超过1小时'))
        return
      }
      // if (this.signInType === '签到后引领到目的地' && !this.robotPT) {
      //   Toast.fail('请选择签到点位')
      //   return
      // }
      // if (this.signInType === '签到后进行讲解' && !this.robotGuide) {
      //   Toast.fail('请选择签到路线')
      //   return
      // }
      let registerMode = undefined
      let robotGuide = undefined
      let robotLocation = undefined
      let robotWorkspaceName = undefined

      if (this.signInType) {
        switch (this.signInType) {
          case this.$t('签到后呼叫接待人'):
            registerMode = ''
            break
          case this.$t('签到后直接开门'):
            registerMode = 'noGuide'
            break
          case this.$t('签到后引领到目的地'):
            registerMode = 'pointGuide'
            robotLocation = this.result && this.result.split('/')[1]
            robotWorkspaceName = this.result && this.result.split('/')[0]
            break
          case this.$t('签到后进行讲解'):
            registerMode = 'routeGuide'
            robotGuide = this.guideList.filter(
              (item) => item.name == this.robotGuide
            )[0].id
            break
        }
      }
      let isOk = true
      if (this.IsSubscribe) {
        const limitStart = moment(this.appointmentInterval, 'HH:mm')
        const limitEnd = moment(this.scheduledEndTime, 'HH:mm')
        const resultStart = this.setTime(this.visitStartTime, 10)
        const resultEnd = this.setTime(this.visitEndTime, 2)
        const dateEnd = moment(resultEnd, 'HH:mm')
        const dateStart = moment(resultStart, 'HH:mm')
        if (limitEnd < dateEnd) {
          Toast.fail(
            this.$t('预约时间最晚为 {slot1} ,您已超出,请重新选择', {
              slot1: this.scheduledEndTime,
            })
          )
          isOk = false
          this.IsSubscribeTitle = this.$t('不可预约')
          return
        }
        if (limitStart > dateStart) {
          Toast.fail(
            this.$t('预约时间最早为 {slot1} ,您已提前,请重新选择', {
              slot1: this.appointmentInterval,
            })
          )
          this.IsSubscribeTitle = this.$t('不可预约')
          isOk = false
          return
        }
        this.IsSubscribeTitle = this.$t('可预约')
        if (this.scheduledMaxTime != 24) {
          const limitCha = this.scheduledMaxTime * 60
          const startTimes = this.setTime(this.visitStartTime, 10)
          const endTimes = this.setTime(this.visitEndTime, 2)
          const newStartTime =
            new Date().getFullYear() +
            '-' +
            this.date +
            ' ' +
            startTimes +
            ':' +
            '00'
          const newEndTime =
            new Date().getFullYear() +
            '-' +
            this.date +
            ' ' +
            endTimes +
            ':' +
            '00'
          const cha = moment(newEndTime).diff(moment(newStartTime), 'minutes')
          if (cha > limitCha) {
            Toast.fail(
              this.$t('会议支持最长预约时间 {slot1}小时 ', {
                slot1: this.scheduledMaxTime,
              })
            )
            isOk = false
            return
          }
        }
        if (isOk == true) {
          try {
            await this.setBookAppointment(
              robotLocation,
              robotWorkspaceName,
              registerMode,
              robotGuide
            )
          } catch (error) {
            console.log(error)
            Toast.fail(this.$t('预约会议失败，请稍后再试'))
            return
          }
        }
      }
      if (isOk == false) {
        return
      }

      this.isConfirm = true
      let newStartTime
      let newEndTime
      if (this.IsSubscribe) {
        const startTime = this.setTime(this.visitStartTime, 10)
        const endTime = this.setTime(this.visitEndTime, 2)
        newStartTime =
          new Date().getFullYear() + '-' + this.date + ' ' + startTime
        newEndTime = new Date().getFullYear() + '-' + this.date + ' ' + endTime
      } else {
        newStartTime =
          new Date().getFullYear() + '-' + this.date + ' ' + this.visitStartTime
        newEndTime =
          new Date().getFullYear() + '-' + this.date + ' ' + this.visitEndTime
      }
      let data = {
        address: this.relexConfig.address,
        meetingRoomId: this.meetingRoom.meetingRoomId,
        companyId: this.relexConfig.companyId,
        developerId: this.relexConfig.companyId * 1,
        interviewee: this.relexConfig.staffId,
        visitPurpose: I18nTemplateForSubmit[this.radio],
        visitTime: newStartTime,
        visitEndTime: newEndTime,
        visitorCompany: this.visitorCompany,
        visitorMobile: this.visitorMobile,
        visitorName: this.visitorName,
        visitorPhoto: this.visitorPhoto,
        visitAcceptedStatus: this.visitAcceptedStatus,
        visitorNumber: this.visitorNumber,
        otherPeopleRecord: [
          {
            name: this.visitorName,
            mobile: this.visitorMobile,
            email: '',
            type: 'visitor',
          },
        ],

        robotLocation: robotLocation || '',
        robotWorkspaceName: robotWorkspaceName || '',
        source: 'H5',
        registerMode: registerMode ?? '',
        robotGuide: robotGuide || '',
        // visitId: null,
        rsaParam: this.publicKey,
      }
      this.isLoading = true
      try {
        if (this.ifUpdate) {
          await visitorUpdate({
            ...data,
            id: this.visitId,
            status: this.status,
            invitationCode: this.invitationCode,
          })
          Toast.success(this.$t('修改成功'))
          this.$router.push('/visitors')
          this.isLoading = false
        } else {
          const netId = await PublicvisitorSave({
            ...data,
            visitType: 'PUBLIC',
          })
          // todo

          Toast.success(this.$t('新建邀约成功'))
          // const visitId = await getVisitFree(netId)

          // if (window.injectData && window.injectData.source == 'NewWorkApp') {
          //   this.sourceIsH5 = false
          //   this.$store.state.visitorState = 'pre'
          //   this.$router.push('/visitors')
          // } else {
          // this.$router.push('/visitors')
          this.$router.push(
            `/publicVisitorInvitationBySelf/?id=${netId}&companyCode=${this.relexConfig.companyCode}`
          )
          // }
          this.isLoading = false
        }
      } catch (error) {
        this.isLoading = false
        console.log('异常', error)
        Toast.fail(error.response.data)
      } finally {
        this.isConfirm = false
      }
    },
    async getFile(data) {
      // const formData = new FormData()
      // formData.append('file', data)
      // try {
      //   this.ifSending = true
      //   const res = await upload(formData)
      //   this.visitorPhoto = res
      //   this.ifSending = false
      // } catch (error) {
      //   this.ifSending = false
      //   this.photo = ''
      //   Toast.fail('照片上传失败! 您需重新上传')
      // }
    },
    getbase64Data(data) {
      this.photo = data
    },
    async onRefresh() {
      await this.getPurposeList('VISITOR_PURPOSE')
      setTimeout(() => {
        Toast(this.$t('刷新成功'))
        this.isLoading = false
      }, 500)
    }, // async ifRobot(companyId) {
    //   // const res = await getRobotWork(companyId)
    //   // let arr = []
    //   // res.leadingServiceStatus && arr.push({ name: '签到后呼叫接待人', value: '' })
    //   // res.leadingServiceStatus &&
    //   //   arr.push({ name: '签到后直接开门', value: 'leadingServiceStatus' })
    //   // res.leadingServiceSecond &&
    //   //   arr.push({ name: '签到后引领到目的地', value: 'leadingServiceSecond' })
    //   // res.leadingServiceThird && arr.push({ name: '签到后进行讲解', value: 'leadingServiceThird' })
    //   // this.signInTypeList = arr
    //   // if (res.pointPositions) {
    //   //   this.PTList = res.pointPositions.map(item => {
    //   //     return { name: item }
    //   //   })
    //   //   // const defaultPT = this.PTList.length > 0 ? this.PTList[0].name : ''
    //   //   // this.tmpRobotPT = defaultPT
    //   //   // this.robotPT = defaultPT
    //   //   // this.result = defaultPT
    //   // }
    //   // if (res.robotGuideName) {
    //   //   this.guideList = res.robotGuideName.split(',').map(item => {
    //   //     return { id: item.split(':')[0], name: item.split(':')[1] }
    //   //   })
    //   // }
    //   // this.getAddress(this.user.companyId)
    //   // if (this.showRobot) this.getSerial()
    // },
    confirmRobot() {},
    confirmRobotGuide() {},
    selectPT() {
      this.tmpRobotPT = ''
      this.robotPT = this.tmpRobotPT
      const item = this.ConferenceColumns.find((item) => {
        return this.tmpRobotPT?.includes(item.name)
      })
      if (!!item) {
        this.setHyValue(item)
      }
      this.showPT = false
    },
    selectGuide(val) {
      this.tmpRobotGuide = val
      this.robotGuide = this.tmpRobotGuide
      this.showGuidePopup = false
    },
    selectSignIn(val) {
      this.signInType = val.name
      val.value == 'leadingServiceSecond'
        ? (this.showRobot = true)
        : (this.showRobot = false)
      val.value == 'leadingServiceThird'
        ? (this.showGuide = true)
        : (this.showGuide = false)
      this.showSignIn = false
    },
    async getAddress(companyId) {
      const res = await getVisitaddress(companyId)
      if (res?.length > 0) {
        this.addressList = res
        this.currentAddress = res[0].address
        this.adderssResult = res[0].id
      }
      this.getPurposeList('VISITOR_PURPOSE')
    },

    selectAddress(val) {
      this.currentAddress = val.address
      this.adderssResult = val.id
      this.showAddress = false
    },
    // async getInfo(id) {
    //   const res = await getVisitFree({ id })
    //   this.visitId = res.id
    //   this.ifUpdate = true
    //   this.userList.forEach(item => {
    //     if (item.id == res.interviewee) {
    //       this.intervieweeName = item.name
    //       this.interviewee = item
    //     }
    //   })
    //   this.buttonText = '确认修改'
    //   this.visitorName = res.visitorName
    //   this.visitorMobile = res.visitorMobile
    //   this.radio = res.visitPurpose
    //   res.visitorPhoto && (this.photo = this.visitorPhoto = res.visitorPhoto)
    //   this.date = dayjs(res.visitTime).format('MM-DD')
    //   this.visitorDate = dayjs(res.visitTime).$d
    //   this.visitorNumber = res.visitorNumber
    //   this.visitorCompany = res.visitorCompany
    //   this.status = res.status
    //   this.invitationCode = res.invitationCode
    //   this.visitAcceptedStatus = res.visitAcceptedStatus
    //   this.visitStartTime = this.tmpTime = dayjs(res.visitTime).format('HH:mm')
    //   this.visitEndTime = this.tmpEndTime = dayjs(res.visitEndTime).format('HH:mm')
    //   if (res.address && this.addressList.length > 0) {
    //     let curAddress = this.addressList.filter(item => item.address == res.address)[0]
    //     if (curAddress) {
    //       this.currentAddress = res.address
    //       this.adderssResult = curAddress.id
    //     }
    //   }
    //   if (res.registerMode && this.signInTypeList.length > 0) {
    //     let arr = this.signInTypeList.map(item => item.name)
    //     switch (res.registerMode) {
    //       case '':
    //         if (arr.includes('签到后呼叫接待人')) {
    //           this.signInType = this.signInResult = '签到后呼叫接待人'
    //         }
    //         break
    //       case 'noGuide':
    //         if (arr.includes('签到后直接开门')) {
    //           this.signInType = this.signInResult = '签到后直接开门'
    //         }
    //         break
    //       case 'pointGuide':
    //         if (arr.includes('签到后引领到目的地')) {
    //           this.signInType = this.signInResult = '签到后引领到目的地'
    //           if (res.robotLocation && res.robotWorkspaceName) {
    //             let pt = this.PTList.filter(
    //               item => item.name == res.robotWorkspaceName + '/' + res.robotLocation
    //             )[0]
    //             if (pt) {
    //               this.robotPT = this.result = pt.name
    //             }
    //           }
    //           this.showRobot = true
    //         }
    //         break
    //       case 'routeGuide':
    //         if (arr.includes('签到后进行讲解')) {
    //           this.signInType = this.signInResult = '签到后进行讲解'
    //           this.showGuide = true
    //           let guide = this.guideList.filter(item => item.id == res.robotGuide)[0]
    //           if (guide) {
    //             this.robotGuide = this.guideResult = guide.name
    //           }
    //         }
    //         break
    //     }
    //   }
    // },
    async fetchAllLang() {
      const langParams = {
        // 0 未发布， 1 已发布
        status: 1,
        companyId: this.user.companyId
      }
      const list = await LanguagesRESTful.list(langParams)

      this.allLang = {
        ...defaultLang,
        ...list?.reduce((acc, { code, name }) => ({ ...acc, [code]: name }), {}),
      }
    },
  },
  computed: {
    locales() { return Object.values(this.allLang) },
    localeLabel() {
      return this.allLang[this.locale]
    }
  },
  mounted() {
    this.getValue()
    this.user = JSON.parse(localStorage.getItem('user'))
    this.interviewee = this.user
    // this.getUsers(this.user.companyId)
    this.photo = require('@/assets/images/upLoad.png')
    this.fetchAllLang()

  },
  setup() {
    const checked = ref('1')
    return { checked }
  },
}
</script>
<style lang="less" scoped>
.newInvitation {
  background: #f6f6f6;

  .content {
    margin-top: 47px;
    overflow: auto;
  }

  .agreeBox {
    padding: 24px 0px 35px;

    .agree-btn {
      border: none;
      width: 351px;
      margin: 0px auto;
      font-size: 16px;
    }
  }

  .purposeBox {
    // margin-top: 12px;
    height: 126px;
    background: #fefffe;
    font-size: 16px;
    color: #333333;
    border-bottom: 1px solid #ededed !important;
    // margin-block: 1px;

    .purpose-title {
      // padding: 0 16px;
      height: 46px;
      line-height: 46px;
    }

    .purpose-radio {
      padding: 0 16px;

      > div {
        margin-top: 12px;
        margin-right: 16px;
      }
    }
  }

  /deep/.photo {
    height: 86px;

    .van-uploader__upload {
      height: 64px;
      width: 64px;
    }

    .van-cell__value {
      display: block;
    }

    .van-uploader__preview-image {
      width: 64px;
      height: 64px;
    }
  }

  /deep/.switchBlock {
    .van-cell__value {
      display: block;
    }
  }

  .numBox {
    width: 88px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #ededed;
    display: flex;

    .num {
      width: 66px;
      line-height: 32px;

      span {
        padding-left: 12px;
      }
    }

    .num-control {
      > div {
        width: 21px;
        height: 15px;
        border: 1px solid #ededed;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 8px;
          height: 8px;
        }
      }
    }
  }
}

.navBar-wrap {
  width: 100%;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
}

.space {
  // margin-top: 12px;
  font-size: 17px;
  color: #333333;
  height: 56px;
  border-bottom: 1px solid #ededed !important;
  // margin-bottom: 1px;
}

.spaceBlock {
  font-size: 17px;
  color: #333333;
  height: 56px;
}

.spaceMargin {
  margin-bottom: 0px;
}

/deep/.van-field__label {
  display: flex;
  align-items: center;
  width: 7em;
  margin-right: -1px;
}

/deep/.van-cell__value {
  display: flex;
  align-items: center;
}

/deep/.van-cell::after {
  border-bottom: 0;
}

.timeBox {
  height: 72px;
  background: #f7f7f7;
  padding: 5px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .time-btn {
    height: 44px;
    background: #009bff;
  }
}

/deep/.date-border {
  color: #009bff;
}

/deep/ .van-nav-bar .van-icon {
  color: #000000;
}

.interviewee {
  height: 100%;
  background: #f6f6f6;

  .interviewee-content {
    padding-top: 92px;
  }

  .select-navBar {
    background: #ffffff;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #ececec;
    font-size: 18px;
    position: relative;

    .arrow {
      height: 100%;
      padding: 3px 19px;
      position: absolute;
    }

    .title {
      font-size: 17px;
      font-weight: 500;
    }
  }

  /deep/.search {
    height: 40px;
    font-size: 14px;

    img {
      height: 16px;
      width: 16px;
    }

    .van-cell__value {
      display: block;
    }
  }

  .searchList {
    font-size: 16px;
    color: #333333;
    padding: 0px 12px;
    background: #ffffff;
    overflow: auto;

    li {
      line-height: 48px;
      padding: 0px 4px;
      border-bottom: 1px solid #ededed;
      display: flex;
      align-items: center;

      span {
        margin-left: 15px;
        color: #999999;
      }
    }
  }
}

.cropper {
  width: 66px;
  height: 66px;
  line-height: 66px;
  /* 切记position: relative一定要有 */
  position: relative;
  overflow: hidden;
  text-align: center;

  .img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}

/deep/.timeList {
  position: relative;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  height: 275px;
  padding-top: 5px;
  padding-left: 16px;
  padding-right: 16px;
  overflow: auto;

  .timeListCard {
    min-height: 52px;
    border-bottom: 1px solid #ebebeb;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    display: block;
    display: flex;
    align-items: center;
    padding-left: 6px;
    font-size: 16px;
    min-height: 50px;
    // line-height: 51px;
    color: #000000;
    word-break: break-word;
    word-wrap: break-word;
  }
}

.bookBox {
  height: 72px;
  background: #f7f7f7;
  padding: 6px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .book-btn {
    height: 44px;
    background: #009bff;
  }
}

.timeInterval {
  padding-left: 13px;
  padding-right: 13px;
}

.time-notice {
  display: flex;
  padding-left: 16px;
  margin-top: 6px;

  img {
    height: 16px;
    width: 16px;
  }

  span {
    padding-left: 4px;
    height: 16px;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
  }
}

.address {
  display: flex;
  align-items: center;

  span {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon-more {
    margin-left: 5px;
    width: 16px;
    height: 16px;
  }
}

.headerBar {
  width: '100%';
  height: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #ededed;
  // margin-bottom: 1px;

  .customerButton {
    width: 240px;
    height: 32px;
    background: #ffffff;
    border-radius: 24px;
    border: 1px solid #009bff;
    margin-right: 9px;
    display: flex;
    justify-content: center;
    align-items: center;

    .customerName {
      font-size: 13px;
      font-weight: 400;
      color: #009bff;
    }
  }

  .historyButton {
    width: 93px;
    height: 32px;
    background: #009bff;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;

    .tabImg {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }

    .historyName {
      font-size: 13px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.hidden {
  display: none;
}
</style>
